export const DEPLOYMENT_MODES = ['SINGLE_ORGANIZATION', 'MULTI_ORGANIZATION'];
export const REFERENCE_DATA_AUTHORITIES = [
    'PLATFORM_MANAGED',
    'ORGANIZATION_MANAGED',
    'DELEGATED_TO_ORGANIZATION',
];
export const DEFAULT_DEPLOYMENT_PROFILE = Object.freeze({
    mode: 'SINGLE_ORGANIZATION',
    referenceDataAuthority: 'ORGANIZATION_MANAGED',
});
export function isOrganizationReferenceDataAuthority(profile) {
    return (profile.mode === 'SINGLE_ORGANIZATION' ||
        profile.referenceDataAuthority === 'ORGANIZATION_MANAGED' ||
        profile.referenceDataAuthority === 'DELEGATED_TO_ORGANIZATION');
}
export function validateDeploymentProfile(profile) {
    if (!DEPLOYMENT_MODES.includes(profile.mode)) {
        throw new Error(`Unsupported deployment mode: ${profile.mode}`);
    }
    if (!REFERENCE_DATA_AUTHORITIES.includes(profile.referenceDataAuthority)) {
        throw new Error(`Unsupported reference-data authority: ${profile.referenceDataAuthority}`);
    }
    if (profile.mode === 'SINGLE_ORGANIZATION' &&
        profile.referenceDataAuthority === 'PLATFORM_MANAGED') {
        throw new Error('Single-organization deployment requires organization-managed reference data');
    }
}
